import React, { createContext } from 'react'
import DateTimeInput from './dateTimeInput'
import DropdownWrapper from './dropdownWrapper'
import RadioGroupWrapper from './radioGroupWrapper'
import TableWrapper from './tableWrapper'
import FileInput from './fileInput'
import NavButtonsList from './list/navButtonsList'
import merge from 'deepmerge'

export const components = {
  TextInput: 'input',
  NumberInput: 'input',
  TextArea: 'textarea',
  CheckBox: 'input',
  DisplayField: ({ value, ...props }) => <span {...props}>{value}</span>,
  RadioGroup: RadioGroupWrapper,
  Dropdown: DropdownWrapper,
  Date: 'input',
  DateTime: DateTimeInput,
  FileInput,
  Table: TableWrapper,
  Button: 'button',
  ErrorIcon: React.Fragment,
  ErrorText: 'span',
  Text: 'span',
  DefaultListContainer: NavButtonsList
}

export const defaults = {
  headerButton: {},
  textInput: {},
  displayField: {},
  numberInput: {},
  textArea: {},
  checkBox: {},
  radioGroup: {},
  date: {},
  dateTime: {},
  file: {},
  button: {},
  dropdown: { isSearchable: true },
  table: {},
  fieldSet: {},
  closeButtonText: 'X',
  wizard: {
    footerButtons: [
      ({ prevPage, currentPage }) => (<button disabled={currentPage === 0} onClick={prevPage}>Back</button>),
      ({ nextPage, currentPage, maxClickableIdx }) => (<button disabled={currentPage === maxClickableIdx} onClick={nextPage}>Next</button>)
    ]
  },
  list: {
    navButtonProps: ({ selected }) => ({ className: selected ? 'selected' : undefined }),
    closeButtonProps: ({ disabled }) => ({ className: 'schema-form__list-delete', style: disabled ? { display: 'none' } : {}, location: 'label' }),
    newButtonProps: { children: 'New' },
    emptyListPlaceholder: 'No items to display.'
  },
  tilesList: {
    closeButtonProps: { location: 'right' }
  }
}

export function evaluateFunctionDefault(def, args) {
  if (typeof def === 'function') return def(args)
  else return def
}

// https://github.com/TehShrike/is-mergeable-object/blob/master/index.js
function isMergeableObject(val) {
  function isSpecial(value) {
    const stringValue = Object.prototype.toString.call(value)
    return stringValue === '[object RegExp]' || stringValue === '[object Date]' || isReactElement(value)
  }
  const canUseSymbol = typeof Symbol === 'function' && Symbol.for
  const REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for('react.element') : 0xeac7
  const isReactElement = (value) => value.$$typeof === REACT_ELEMENT_TYPE

  return val && (typeof val === 'function' || typeof val === 'object') && !isSpecial(val)
}
export function combineProps(...propSources) {
  return merge.all(propSources.filter(x => x).reverse(), {
    isMergeableObject,
    clone: false,
    customMerge: key => ((a, b) => {
      if (typeof a === 'function' || typeof b === 'function') {
        return (args) => merge(evaluateFunctionDefault(a, args), evaluateFunctionDefault(b, args))
      } else {
        return merge(a, b)
      }
    })
  })
}

export const SchemaContext = createContext()
export const EditModeContext = createContext(false)
export const NamePrefixContext = createContext('')
export const ErrorPathContext = createContext('')
export const DisabledContext = createContext(false)
